export const ANWB_DEMO_ENABLED = import.meta.env.VITE_FEATURE_ANWB_DEMO === "true";

export const BRAND_IDS = ["lekkerladen", "anwb"] as const;

export type BrandId = (typeof BRAND_IDS)[number];

type Brand = {
  id: BrandId;
  name: string;
  chat: boolean;
  cornerPattern: boolean;
  volumeBenefit: boolean;
};

const BRANDS: Record<BrandId, Brand> = {
  lekkerladen: {
    id: "lekkerladen",
    name: "Lekkerladen",
    chat: true,
    cornerPattern: true,
    volumeBenefit: true,
  },
  anwb: {
    id: "anwb",
    name: "ANWB",
    chat: false,
    cornerPattern: false,
    volumeBenefit: false,
  },
};

const COOKIE = "brand";

function isBrandId(value: unknown): value is BrandId {
  return BRAND_IDS.some((id) => id === value);
}

function resolveBrandId(): BrandId {
  if (!ANWB_DEMO_ENABLED) return "lekkerladen";

  const fromCookie = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${COOKIE}=`))
    ?.slice(COOKIE.length + 1);
  return isBrandId(fromCookie) ? fromCookie : "lekkerladen";
}

export const BRAND: Brand = BRANDS[resolveBrandId()];

export async function applyBrand() {
  if (BRAND.id === "anwb") await import("./anwb.css");

  document.documentElement.dataset.brand = BRAND.id;
  document.title = BRAND.name;
  document
    .querySelector('meta[name="apple-mobile-web-app-title"]')
    ?.setAttribute("content", BRAND.name);
}
